import { Button, Flex, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const DEMO_URL = 'https://cal.com/fluenceur/30min';

const ctaProps = {
  variant: 'outline',
  size: 'sm',
  h: { base: '34px', md: '36px' },
  px: { base: 3, md: 4 },
  borderRadius: '12px',
  borderColor: 'gray.200',
  color: 'primary.900',
  bg: 'transparent',
  fontFamily: 'heading',
  fontSize: { base: '12px', md: '13px' },
  fontWeight: 'semibold',
  flexShrink: 0,
  _hover: { bg: 'gray.50', borderColor: 'gray.400', textDecoration: 'none' },
} as const;

/**
 * "No account yet?" and its way forward: a free account while the brand self
 * sign-up is open, the demo booking otherwise. Nothing while the switch is
 * still being read, so the page never shows one link and swaps it.
 */
export const AuthTopBarAction = ({ selfSignupOpen }: { selfSignupOpen: boolean | undefined }) => {
  const { t } = useTranslation();

  if (selfSignupOpen === undefined) return null;

  return (
    <Flex align="center" justify="flex-end" gap={{ base: 2, md: 3 }} flexShrink={0}>
      {/* Hidden while the brand panel halves the form pane (lg to xl): the
          sentence would otherwise run over the logo. */}
      <Text
        display={{ base: 'none', sm: 'block', lg: 'none', xl: 'block' }}
        fontSize="14px"
        color="gray.600"
        whiteSpace="nowrap"
      >
        {t('auth.noAccount')}
      </Text>
      {selfSignupOpen ? (
        <Button asChild {...ctaProps}>
          <RouterLink to="/signup">{t('authPage.footerSignup')}</RouterLink>
        </Button>
      ) : (
        <Button asChild {...ctaProps}>
          <Link href={DEMO_URL} _hover={{ textDecoration: 'none' }}>
            {t('authPage.getDemo')}
          </Link>
        </Button>
      )}
    </Flex>
  );
};
